import React, { ReactNode } from 'react';

import { Typography } from '@mui/material';

export const TranscriptHeaderPercentContainer = ({ children }: { children: ReactNode }) => {
  return (
    <Typography
      display="block"
      sx={{
        backgroundColor: '#1BFFAF',
        borderRadius: 1,
        p: '2px 8px',
      }}
      variant="text3"
    >
      {children}
    </Typography>
  );
};
